export default function PHP_die() {
  return (
    <div>
      <h1>PHP_die</h1>
    </div>
  );
}
